const rule = () => ({
    margin: '5rem 2.5rem',
    '> img': {
        margin: 'auto',
        display: 'block',
        width: '10rem',
        borderRadius: '16px',
    },
    '> h1': {
        margin: '1rem 0 2.5rem 0',
        textAlign: 'center',
    },
});

export default rule;
